import Swal from "sweetalert2";
const alertC = (title1, text, icon1, title2, textcolor, iconColor) =>
  Swal.fire({
    title: title1,
    text: text,
    icon: icon1,
    confirmButtonColor: "#3085d6",
    confirmButtonText: title2,
    color: textcolor ? textcolor : "",
    iconColor: iconColor ? textcolor : "",
  });

export default alertC;
